module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo-white@2x.2694fdf1.png";